import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import {masksRef, reservationsRef, fire, systemRef} from '../firebase/firebaseConfig'

masksRef.onSnapshot((masksR) => {
  let localCopy = []
  masksR.forEach((doc) => {
    const mask = doc.data()
    mask.uuid = doc.id
    localCopy.push(mask)
  })
  store.commit('setMasks', localCopy)
})
if(localStorage.getItem("oro-reservation")) {
  reservationsRef.doc(localStorage.getItem('oro-reservation'))
    .onSnapshot(function(doc) {
      if (doc.exists) {
        store.commit('setReservationList', {...doc.data(), id: doc.id})
      } else {
        store.commit('setReservationList')
        localStorage.removeItem("oro-reservation");
      }
    })
}
let addPendingReservation = function(masks) {
  if (masks && masks[0] && masks[0].uuid) {
    let mask = store.getters.getMaskByUuid(masks[0].uuid)
    let update = {
      pending: fire.firestore.FieldValue.increment(masks.length)
    }
    masksRef.doc(mask.uuid).update(update).then(function() {
    }).catch(function(error) {
      console.log('error', error)
    })
  }
}

systemRef.doc('/visitor').onSnapshot((system) => {
  store.commit('setSystem', system.data())
})

export const store = new Vuex.Store({
    state:{
      masks: [],
      reservationList: [],
      user: {},
      modal: null,
      imageModal: null,
      currentRoute: '',
      reservationSent: false,
      system: {}
    },
    mutations: {
      setReservationSent(state, status) {
        state.currentRoute = status
      },
      setCurrentRoute(state, route) {
        state.currentRoute = route
      },
      setMasks(state, masks) {
        state.masks = [...masks]
      },
      setModal(state, info) {
        state.modal = info
      },
      setImageModal(state, info) {
        state.imageModal = info
      },
      setSystem(state, info) {
        state.system = info
      },
      setReservationList(state, list) {
        if (!list) { list = []}
        state.reservationList = list
      },
      sendCompleteEmail(state, res) {
        let path = {
          emailCompleteSent: new Date(),
          updated: new Date()
        }
        reservationsRef.doc(res.uuid).update(path).then(function() {

          var data = new FormData();
          data.append("name", res.name);
          data.append("email", res.email);
          data.append("phone", '1');
          data.append("summary", '1');
          data.append("templateID", '1513187');

          var xhr = new XMLHttpRequest();
          xhr.withCredentials = true;

          xhr.addEventListener("readystatechange", function() {
            if(this.readyState === 4) {
              console.log('email sent');
            }
          });

          xhr.open("POST", "https://giyo.us/api/mail.php/");

          xhr.send(data);
        })
      },
      submitReservation(state, form) {
        state.reservationSent = true
        let path = {
          submitted: new Date(),
          updated: new Date(),
          ...form
        }

        let summaryText = ''
        state.reservationList.masks.forEach(mask => {
          summaryText = summaryText + '<div style="font-family:Arial,sans-serif;font-size:16px;letter-spacing:normal;line-height:1;text-align:left;color:#5e6977;padding:5px;">' + mask.name + ': ' + mask.type + ' size ' + mask.size.toUpperCase() + '  </div>'
        });

        reservationsRef.doc(state.reservationList.id).update(path).then(function() {
          state.modal = null
          localStorage.removeItem("oro-reservation")
          state.reservationList = []

          var data = new FormData();
          data.append("name", form.name);
          data.append("email", form.email);
          data.append("phone", form.phone);
          data.append("summary", summaryText);
          data.append("waittime", form.waittime || "2");
          data.append("templateID", '1485334');

          var xhr = new XMLHttpRequest();
          xhr.withCredentials = true;

          xhr.addEventListener("readystatechange", function() {
            if(this.readyState === 4) {
              console.log('email sent');
            }
          });

          xhr.open("POST", "https://giyo.us/api/mail.php/");

          xhr.send(data);
        })
      },
      addToReservation(state, masks) {
        // let updated = {...this.reservation.masks[i], size: size}
        // delete updated.idcapital: firebase.firestore.FieldValue.delete()
        let updatedMasks = [...state.reservationList.masks, ...masks]
        let path = {
          masks: updatedMasks,
          updated: new Date(),
        }
        // path['masks.'+i] = fire.firestore.FieldValue.delete()
        reservationsRef.doc(state.reservationList.id).update(path).then(function() {
          addPendingReservation(masks)
          state.reservationList.masks = updatedMasks
          state.modal = null
        }).catch(function(error) {
          console.log('error', error)
        })
      },
      initiateReservation(state, masks) {
        let currentReservationList = [...masks]
        let newReservation = {
          initiated: new Date(),
          updated: new Date(),
          masks: [...currentReservationList]
        }
        reservationsRef.add(newReservation).then((reservation) => {
          addPendingReservation(currentReservationList)
          localStorage.setItem('oro-reservation', reservation.id);
          reservationsRef.doc(reservation.id)
            .onSnapshot(function(doc) {
              if (doc.exists) {
                store.commit('setReservationList', {...doc.data(), id: doc.id})
              } else {
                localStorage.removeItem("oro-reservation");
              }
            })
          state.modal = null
          // this.$router.push({name: 'editmask', params: {id: oroId}})
        }).catch(function(error) {
          console.log('error adding', error)
        })
      },
      setUser(state, user) {
        state.user = {...user}
      },
      logOut(state) {
        state.user = {}
      }
    },
    getters: {
      getReservationSent: state => {
        return state.reservationSent
      },
      getCurrentRoute: state => {
        return state.currentRoute
      },
      getModal: state => {
        return state.modal
      },
      getImageModal: state => {
        return state.imageModal
      },
      getMasks: state => {
        return state.masks
      },
      getSystem: state => {
        return state.system
      },
      getUser: state => {
        return state.user
      },
      getReservationList: state => {
        return state.reservationList
      },
      getMask: (state) => (id) => {
        return state.masks.find(mask=> mask.id == id)
      },
      getMaskByUuid: (state) => (uuid) => {
        return state.masks.find(mask=> mask.uuid == uuid)
      }
    }
})
